import * as React from 'react';

import {CardWidget} from 'shells/card/card-widget/card-widget';
import type {
    AddButtonProps,
    BaseProps,
    EmptyStateProps,
    ErrorProps,
    WidgetTabProps,
} from 'shells/card/card-widget/card-widget';

import type {WidgetFragment as Widget} from 'nutshell-graphql-types';

import {useUpdateWidgetCollapseState} from './graphql/hooks';

type Props = {
    widget: Widget;
} & BaseProps & {
        addButtonProps?: AddButtonProps;
        secondaryAddButtonProps?: AddButtonProps;
        setIsAdding?: (isAdding: boolean) => void;
        errorProps?: ErrorProps;
        emptyStateProps?: EmptyStateProps;
        tabProps?: WidgetTabProps;
        collapsedContent?: React.ReactNode;
    };

export const CollapsibleCardWidget = (props: Props) => {
    const {widget, setIsAdding, collapsedContent, ...restProps} = props;

    const {updateWidgetCollapseState} = useUpdateWidgetCollapseState();

    const handleToggle = React.useCallback(() => {
        if (setIsAdding && !widget.isCollapsedForUser) {
            setIsAdding(false);
        }

        updateWidgetCollapseState({
            widget: widget.id,
            isCollapsed: !widget.isCollapsedForUser,
        });
    }, [updateWidgetCollapseState, widget.id, widget.isCollapsedForUser, setIsAdding]);

    return (
        <CardWidget
            {...restProps}
            title={widget.name}
            type={widget.type}
            collapsibleProps={{
                isCollapsed: widget.isCollapsedForUser,
                onToggle: handleToggle,
                collapsedContent: collapsedContent,
            }}
        />
    );
};
